export const messages = {
  en: {
    productGroupOrderManage: {
      queryCondition: 'Query Conditions',
      orderIdPlaceholder: 'Please enter order ID',
      productNamePlaceholder: 'Please enter product name',
      buyerPlaceholder: 'Please enter buyer name',
      groupLeaderPlaceholder: 'Please select group leader',
      statusPlaceholder: 'Please select status',
      allStatus: 'All Status',
      groupSuccess: 'Group Success',
      groupFail: 'Group Fail',
      grouping: 'Grouping',
      query: 'Query',
      groupOrder: 'Group Orders',
      orderId: 'Order ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      buyer: 'Buyer',
      groupLeader: 'Group Leader',
      purchaseQuantity: 'Quantity',
      groupSize: 'Group Size',
      groupAmount: 'Group Amount',
      status: 'Status',
      rebateAmount: 'Rebate Amount',
      openTime: 'Open Time',
      groupTime: 'Group Time',
      deadline: 'Deadline'
    }
  },
  zh: {
    productGroupOrderManage: {
      queryCondition: '查询条件',
      orderIdPlaceholder: '请填写订单',
      productNamePlaceholder: '请填写产品名称',
      buyerPlaceholder: '请填写购买者',
      groupLeaderPlaceholder: '请选择团长',
      statusPlaceholder: '请选择状态',
      allStatus: '全部状态',
      groupSuccess: '拼团成功',
      groupFail: '拼团失败',
      grouping: '拼团中',
      query: '查询',
      groupOrder: '拼团订单',
      orderId: '订单ID',
      productImage: '商品图片',
      productName: '商品名称',
      buyer: '购买者',
      groupLeader: '团长',
      purchaseQuantity: '购买数量',
      groupSize: '拼团人数',
      groupAmount: '拼团金额',
      status: '状态',
      rebateAmount: '返佣金额',
      openTime: '开团时间',
      groupTime: '拼团时间',
      deadline: '截止时间'
    }
  }
}